import { createContext } from 'react';
import { TransportOrderRequest, TransportServices } from '../../../models/transport';
import { CONSTANTS } from 'config/constants';

const { TRANSPORT_DEADLINES } = CONSTANTS;

export type AddTransportContextType = {
    transportOrderReq: TransportOrderRequest;
    setTransportOrderReq: (v: TransportOrderRequest) => void;
};

export const AddTransportContext = createContext<AddTransportContextType>({
    transportOrderReq: {
        lab: null,
        clinic: null,
        date: null,
        serviceCode: TransportServices.PICKUP,
        manualPackageCount: 1,
        deadline: null,
    },
    setTransportOrderReq: () => undefined,
});

export const emptyTransportOrderReq = (
    serviceCode: TransportServices = TransportServices.PICKUP,
): TransportOrderRequest => {
    return {
        lab: null,
        clinic: null,
        date: null,
        serviceCode: serviceCode,
        manualPackageCount: 1,
        deadline: TRANSPORT_DEADLINES[0],
    };
};
